import * as Yup from 'yup';

import { isValidEmail, isValidPhone } from '../../../lib/helpers/validation.helpers';
import { messages } from './parent-add-contact.messages';

// A contact needs at least one reachable credential. The rule hangs off both
// fields so clearing either one re-surfaces the error on the other.
const CREDENTIAL_TEST = 'credential-present';

interface ICredentialSiblings {
  email?: string;
  phone?: string;
}

function hasCredential(this: { parent: ICredentialSiblings }, value?: string) {
  const { email, phone } = this.parent;
  return !!((value || '').trim() || (email || '').trim() || (phone || '').trim());
}

// A duplicate credential is deliberately absent: parentAddPlayerContact refuses
// it and names the field, which the container turns into that field's error.
export const validationSchema = Yup.object().shape({
  player: Yup.object().nullable().required(messages.errPlayerRequired.defaultMessage),
  name: Yup.string().trim().required(messages.errNameRequired.defaultMessage),
  email: Yup.string()
    .nullable()
    .test('valid-email', messages.errEmailInvalid.defaultMessage, (value) => !value || isValidEmail(value))
    .test(CREDENTIAL_TEST, messages.errCredentialRequired.defaultMessage, hasCredential),
  phone: Yup.string()
    .nullable()
    .test('valid-phone', messages.errPhoneInvalid.defaultMessage, (value) => !value || isValidPhone(value))
    .test(CREDENTIAL_TEST, messages.errCredentialRequired.defaultMessage, hasCredential),
});
